import ChatGatewayObserver from 'app/gateway_observers/ChatGatewayObserver';
import ConfigurationGatewayObserver from 'app/gateway_observers/ConfigurationGatewayObserver';
import MessageGatewayObserver from 'app/gateway_observers/MessageGatewayObserver';
import SelfServiceGatewayObserver from 'app/gateway_observers/SelfServiceGatewayObserver';

export default function(context) {
  context.gateways.chatGateway.addObserver(new ChatGatewayObserver(context));
  context.gateways.configurationGateway.addObserver(new ConfigurationGatewayObserver(context));
  context.gateways.messageGateway.addObserver(new MessageGatewayObserver(context));
  context.gateways.selfServiceGateway.addObserver(new SelfServiceGatewayObserver(context));
}
